import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDown } from './DBDropDown';

class DBDropDownObjective extends React.Component {

    handleValueChange(event) {
        if (this.props.onChange) {
            this.props.onChange(event);
        }
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    render() {
        return (
            <DBDropDown
                noteId={this.props.noteId}
                entity={this.props.entity}
                entityKeyColumn={this.props.entityKeyColumn}
                entityKeyValue={this.props.entityKeyValue}
                field={this.props.field}
                className={this.props.className}
                title={this.props.title}
                placeholder={this.props.placeholder}
                disabled={this.props.disabled}
                customOptions={this.props.customOptions}
                masterEntity={this.props.masterEntity}
                masterEntityKeyColumn={this.props.masterEntityKeyColumn}
                masterEntitySort={this.props.masterEntitySort}
                masterEntityDisplay={this.props.masterEntityDisplay}
                onChange={(event) => this.handleValueChange(event)}
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteType = parseInt(ownprops.noteId.split("_")[0]);
    let pk = parseInt(ownprops.noteId.split("_")[1]);
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    return {
        objUpdated, 
        pk
    };
}

const connectedDBDropDownObjective = connect(mapStateToProps, mapDispatchToProps)(DBDropDownObjective);
export { connectedDBDropDownObjective as DBDropDownObjective };